import { useId } from 'react'

/*
 * Stable, SSR-safe id for SVG gradients, masks and filters.
 * React ids can contain characters that are awkward inside url(#...),
 * so only letters and digits are kept.
 */
export const useSvgId = (prefix: string): string => {
    const id = useId()

    return `${prefix}-${id.replace(/[^a-zA-Z0-9]/g, '')}`
}
